class VideoReviews extends HTMLElement {
  connectedCallback() {
    this.#initSwiper();
    this.#attachListeners();
  }

  #initSwiper() {
    new Swiper(this.querySelector(".vreviews__swiper"), {
      speed: 400,
      mousewheel: true,
      rewind: true,

      slidesPerView: 1,
      spaceBetween: 30,
      pagination: true,

      breakpoints: {
        768: {
          slidesPerView: 2,
        },
      },

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }

  #attachListeners() {
    const $popup = $("#vreviews-popup");
    const $content = $popup.find("#vreviews-popup-content");

    $(".vreviews__item-img").on("click", function () {
      $popup.attr("data-state", "open");

      const videoUrl = $(this).attr("data-video-url");
      if (!videoUrl) {
        return;
      }

      const video = $("<video>", {
        src: videoUrl,
        type: "video/mp4",
        controls: true,
      });

      $content.append(video);
    });

    $("#vreviews-popup .vreviews-popup__close-btn").on("click", () => {
      $popup.attr("data-state", "closed");
      $content.empty();
    });
  }
}
customElements.define("video-reviews-swiper", VideoReviews);
